import * as React from "react";
export function SvgSchemaViewerBoolCalcDiscrete(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={17} {...props}>
      <path
        fill="#367e9c"
        d="M18 6V5h-4v7h1V9h2V8h-2V6zM11 3h1v11h-1zM10 5H5v1h2v6h1V6h2zM1 9h3v1H1zM1 7h3v1H1z"
      />
    </svg>
  );
}
